<template>
  <div class="thank-you">
    <div class="header">
      <img :src="partnerLogoUrl" alt="Logo">
    </div>
    <div class="msg">
      <h2>{{ $t(`datacapture.${firstLineMsg}`) }} </h2>
      <h4>{{ $t(`datacapture.${secondLineMsg}`) }} </h4>
    </div>
  </div>
</template>

<script>
import { getPartnerLogo } from '@/utils.js'
import { tokenStore } from '@/stores/tokenStore.js'
export default {
  name: 'ThankYou',
  props: {
    firstLineMsg: {
      type: String,
      default: 'dataHasBeenSent'
    },
    secondLineMsg: {
      type: String,
      default: 'closeThePage'
    }
  },
  data() {
    return {
      partnerLogoUrl: null,
      tokenStore: tokenStore()
    }
  },
  mounted() {
    this.partnerLogoUrl = getPartnerLogo(this.tokenStore.payload.partner)
    this.tokenStore.clearToken()
  }
}
</script>

<style lang="scss">
@media (min-width: 600px) {
  .thank-you {
    width: 75%;
  }
}

.thank-you {
  width: 90%;
  margin: 1em auto 0 auto;
  height: calc(100% - 1em);
}

.msg {
  width: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.8em;

  h4 {
    margin-top: 0.5em;
  }
}
</style>
